var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      attrs: {
        loading: _vm.$apollo.queries.suitableContractors.loading,
        hasData: _vm.suitableContractors.length > 0,
      },
    },
    [
      _c(
        "div",
        { staticClass: "grid grid-cols-2 gap-x-3 mt-3" },
        _vm._l(_vm.suitableContractors, function (suitableContractor, index) {
          return _c(
            "CustomisedcontractorRequestCard",
            {
              key: index,
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function () {
                      return [
                        suitableContractor.user.contracts[0] &&
                        suitableContractor.user.contracts[0].managers.length >
                          0 &&
                        suitableContractor.user.contracts[0].managers[0]
                          .approved
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "h-full bg-green-300 text-lightGreen rounded-xl p-2 absolute left-0",
                              },
                              [_vm._v("Access Granted")]
                            )
                          : _vm._e(),
                        _vm.getIsEmployeeTagShown(suitableContractor)
                          ? _c("EmployeeTag", {
                              attrs: {
                                fullName: _vm.getContractorFullName(
                                  suitableContractor.user
                                ),
                                initials: _vm.getContractorInitials(
                                  suitableContractor.user
                                ),
                                avatar: suitableContractor.user.avatar,
                                appliedTag: suitableContractor.tag,
                                contractorId: suitableContractor.id,
                                userUpdatedDate:
                                  suitableContractor.user.updated_at,
                              },
                              on: { tagUpdated: _vm.handleRefetch },
                            })
                          : _vm._e(),
                        _c("ContractorRating", {
                          attrs: {
                            ratingTotal:
                              suitableContractor.contractor_ratings_aggregate,
                          },
                        }),
                        _c("ToggleFavorite", {
                          attrs: {
                            currentUserId: _vm.currentUser.id,
                            contractorUserId: suitableContractor.user.id,
                            favorites:
                              suitableContractor.user.favorited_by_users,
                          },
                          on: { updated: _vm.handleRefetch },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "footer",
                    fn: function () {
                      return [
                        _c(
                          "RouterLink",
                          {
                            attrs: {
                              to: {
                                name: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                params: { id: suitableContractor.id },
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex transform hover:text-purple-500 hover:scale-110 rounded-xl",
                              },
                              [
                                _c(
                                  "UiButton",
                                  {
                                    staticClass: "mr-0",
                                    attrs: {
                                      id: "viewContractorProfile",
                                      variant: "blue",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "icon",
                                          fn: function () {
                                            return undefined
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-initial" },
                                      [_vm._v("View Profile")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            },
            [
              [
                _c("div", { staticClass: "grid grid-cols-5" }, [
                  _c("div", { staticClass: "col-span-2 ml-3 -mt-5" }, [
                    _c(
                      "div",
                      { staticClass: "rounded-full transform -m-1" },
                      [
                        suitableContractor.user.avatar
                          ? [
                              _c(
                                "RouterLink",
                                {
                                  attrs: {
                                    to: {
                                      name: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                      params: { id: suitableContractor.id },
                                    },
                                  },
                                },
                                [
                                  _vm._t(
                                    "image",
                                    function () {
                                      return [
                                        _c("S3Image", {
                                          class: [
                                            _vm.defaultImageClasses,
                                            _vm.avatarStyleClasses,
                                          ],
                                          attrs: {
                                            s3FileKey:
                                              suitableContractor.user.avatar,
                                          },
                                        }),
                                      ]
                                    },
                                    {
                                      defaultClasses: [
                                        _vm.defaultImageClasses,
                                        _vm.avatarStyleClasses,
                                      ],
                                      image: suitableContractor.user.avatar,
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          : [
                              _c(
                                "RouterLink",
                                {
                                  attrs: {
                                    to: {
                                      name: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                      params: { id: suitableContractor.id },
                                    },
                                  },
                                },
                                [
                                  _vm._t(
                                    "initial",
                                    function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.defaultInitialsClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            style: _vm.bgStyle,
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xs leading-none font-semibold text-white",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    suitableContractor.user.given_name
                                                      .trimStart()[0]
                                                      .toUpperCase()
                                                  ) +
                                                    _vm._s(
                                                      suitableContractor.user.family_name
                                                        .trimStart()[0]
                                                        .toUpperCase()
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    {
                                      defaultClasses: [
                                        _vm.defaultInitialsClasses,
                                        _vm.avatarStyleClasses,
                                      ],
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                      ],
                      2
                    ),
                    _c("div", [
                      _c("div", [
                        suitableContractor.user.available
                          ? _c("div", {
                              staticClass:
                                "h-4 w-4 border-2 border-white bg-lightGreen rounded-full -mt-2 z-100 relative",
                            })
                          : _vm._e(),
                        !suitableContractor.user.available
                          ? _c("div", {
                              staticClass:
                                "h-4 w-4 border-2 border-white bg-red-600 rounded-full -mt-2 z-100 relative",
                            })
                          : _vm._e(),
                        suitableContractor.user.available
                          ? _c("p", { staticClass: "text-gray-500" }, [
                              _vm._v("Available"),
                            ])
                          : _vm._e(),
                        !suitableContractor.user.available
                          ? _c("p", { staticClass: "text-gray-500" }, [
                              _vm._v("Unavailable"),
                            ])
                          : _vm._e(),
                      ]),
                      _c("p", { staticClass: "font-extrabold" }, [
                        _vm._v(
                          _vm._s(suitableContractor.user.given_name) +
                            " " +
                            _vm._s(suitableContractor.user.family_name)
                        ),
                      ]),
                      _c("p", { staticClass: "text-gray-500" }, [
                        _vm._v(
                          _vm._s(suitableContractor.user.profile.job_title)
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "col-span-3" }, [
                    _c("div", { staticClass: "grid grid-cols-4 gap-x-1" }, [
                      _c("p", { staticClass: "text-gray-500 col-span-1" }, [
                        _vm._v("Rate"),
                      ]),
                      _c("p", { staticClass: "col-span-3" }, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.getFormattedNumber(
                                suitableContractor.user.profile.min_rate
                              )
                            ) +
                            " - $" +
                            _vm._s(
                              _vm.getFormattedNumber(
                                suitableContractor.user.profile.max_rate
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid grid-cols-4 gap-x-1" }, [
                      _c("p", { staticClass: "text-gray-500 col-span-1" }, [
                        _vm._v("Location"),
                      ]),
                      _c("p", { staticClass: "col-span-3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getFullLocation(
                              suitableContractor.user.profile.city,
                              suitableContractor.user.profile.country
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "grid grid-cols-4 gap-x-1" }, [
                      _c("p", { staticClass: "text-gray-500 col-span-1" }, [
                        _vm._v("Company"),
                      ]),
                      _c("p", { staticClass: "col-span-3" }, [
                        _vm._v(
                          _vm._s(_vm.getBusinessName(suitableContractor.user))
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c(
                          "CardBodyItemSkill",
                          { attrs: { label: "Skills" } },
                          [
                            _c("ItemChipsWithMore", {
                              attrs: {
                                items:
                                  suitableContractor.user.profile.skills.map(
                                    ({ skill }) => skill
                                  ),
                                limit: 3,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
            ],
            2
          )
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }